import React, { useEffect, useState } from 'react';
// Api
import client from '../../../api/client';
// Constants
import { GET_ALL_MAILING_LIST_SUBSCRIBERS_API } from '../../../utils/constants/ApiRoutes';
// Components
import ConfirmModal from '../../modals/ConfirmModal';
import MailingListAdminSubscriberSection from './MailingListAdminSubscriberSection';
import useConfirmAction from '../../../hooks/useConfirmAction';

function MailingAdminPageMainContainer() {
  const confirmActionState = useConfirmAction();

  const [mailingListSubscribers, setMailingListSubscribers] = useState([]);
  const [isLoadingSubscriberList, setIsLoadingSubscriberList] = useState(false);

  useEffect(() => {
    fetchMailingListSubscribers();
  }, []);

  const fetchMailingListSubscribers = () => {
    setIsLoadingSubscriberList(true);

    client
      .get(GET_ALL_MAILING_LIST_SUBSCRIBERS_API, false)
      .then((res) => {
        setMailingListSubscribers(res.data.subscribers);
        setTimeout(() => {
          setIsLoadingSubscriberList(false);
        }, 500); // 0.5 second delay
      })
      .catch((err) => {
        console.error('Unable to retrieve callback form data', err);
        setTimeout(() => {
          setIsLoadingSubscriberList(false);
        }, 500); // 0.5 second delay on error too
      });
  };

  return (
    <main
      role='main'
      className='grid w-full h-full overflow-hidden px-8 pt-12 pb-6 lg:container lg:max-w-3xl lg:mx-auto'
      aria-label='Admin mailingList main contaiber'
    >
      <section className='grid w-full h-full'>
        <MailingListAdminSubscriberSection
          mailingListSubscribers={mailingListSubscribers}
          setMailingListSubscribers={setMailingListSubscribers}
          {...confirmActionState}
          fetchMailingListSubscribers={fetchMailingListSubscribers}
          isLoadingSubscriberList={isLoadingSubscriberList}
        />
      </section>

      {/* Confirm Modal */}
      {confirmActionState.modalOpen && (
        <ConfirmModal
          onClose={() => confirmActionState.setModalOpen(false)}
          onConfirm={confirmActionState.handleModalConfirm}
          header={confirmActionState.modalContent.header}
          message={confirmActionState.modalContent.message}
        />
      )}
    </main>
  );
}

export default MailingAdminPageMainContainer;
